export default "__VITE_ASSET__CymjWXLV__"